import styled from "@emotion/styled";
import {
  ActionIcon,
  type ActionIconProps,
  Burger,
  type BurgerProps,
  createPolymorphicComponent,
  Flex as MFlex,
  type FlexProps as MFlexProps,
} from "@mantine/core";

export const LogbookPageContainer = styled.div`
  padding: 1.5% 5%;
  max-width: calc(100vw - 7px);
  min-height: calc(100vh - 104px);
  background-color: ${({ theme }) => theme.colors.background[0]};
`;

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px 50px 30px 50px;
  height: calc(100vh - 104px);
  max-width: calc(100vw);
  overflow-y: scroll;
  scroll-behavior: smooth;
  background-color: ${({ theme }) => theme.colors.background[0]};
`;

export const CardsContainer = styled.div`
  padding: 50px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 50px;
`;

export const Divider = styled.div`
  margin-top: 24px;
  padding: 0 24px;
  border-top: 1px solid ${({ theme }) => theme.colors.main[9]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.main[9]};
`;

export const SmallDivider = styled(Divider)`
  margin-top: 10px;
`;

export const LayoutContainer = styled.div`
  width: 100%;
  padding: 50px;
  display: flex;
  flex-direction: row;
  border: 1px solid ${({ theme }) => theme.colors.main[9]};
  box-shadow: rgba(0, 0, 0, 0.24) 0px 2px 6px;
  background-color: ${({ theme }) => theme.colors.settingsSectionBg};
  color: ${({ theme }) => theme.colors.settingsColor};
  margin-top: 30px;
  border-radius: 6px;
`;

export const ButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const SectionDivider = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.settingsColor};
  padding-bottom: 10px;
  width: 80%;styles={{ width: "100%" }}

  ${({ mr, mb, error }: { mr?: string; mb?: number; error?: boolean }) =>
    `${error ? "border-color: red; color: red;" : ""}
     ${mb ? `margin-bottom: ${mb}px;` : ""}
     ${mr ? `margin-right: ${mr};` : ""}
  `}
`;

interface FlexProps extends MFlexProps {
  flex?: number;
  center?: boolean;
}

const _Flex = styled(MFlex)`
  ${({ flex }: FlexProps) => flex && `flex: ${flex};`}
  ${({ center }: FlexProps) =>
    center &&
    `
    justify-content: center;
    align-items: center;
  `}
`;

export const Flex = createPolymorphicComponent<"div", FlexProps>(_Flex);

const _StyledBurger = styled(Burger)`
  div,
  div::before,
  div::after {
    background-color: ${({ theme }) => theme.colors.main[6]};
  }
`;

export const StyledBurger = createPolymorphicComponent<"button", BurgerProps>(
  _StyledBurger,
);

export const StyledActionIcon = createPolymorphicComponent<
  "button",
  ActionIconProps
>(styled(ActionIcon)`
  svg {
    stroke: ${({ theme }) => theme.colors.main[9]};
  }
`);
